// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.
import { select2RemoteAjax } from './select2_remote';

(function() {

$(document).on("turbo:load", function() {

  // クリアボタン conflictで使用
  $('.clear-button').on('click', function(ev) {
    ev.preventDefault();
    $(this.form).find('input, select, textarea').not(':button, :submit, :reset, :hidden').val('');
  });

  // 詳細検索リセットボタン
  $('#reset-search-form').on('click', function(ev) {
    ev.preventDefault();
    const form = $(this).closest('form');
    form.find('input[type="text"], input[type="email"], select, textarea').val('');
    form.find('input[type="radio"], input[type="checkbox"]').prop('checked', false);
  });

  $(".form_datetime").datetimepicker({
    locale: $('html').attr('lang') || "ja",
    format: 'YYYY/MM/DD HH:mm',
    sideBySide: true
  });
  $(".form_date").datetimepicker({
    locale: $('html').attr('lang') || "ja",
    format: 'YYYY/MM/DD',
    sideBySide: true
  });

  if ($("#contact_user_id").is(':visible')) {
    $("#contact_user_id").select2({placeholder: $("#contact_user_id").data("placeholder")});
  }
  $("#contact_lawyer_ids").select2({placeholder: $("#contact_lawyer_ids").data("placeholder"), allowClear: true});
  $("#contact_secretary_ids").select2({placeholder: $("#contact_secretary_ids").data("placeholder"), allowClear: true});

  // 所属先（親連絡先）検索
  const $parentSelect = $('select#contact_parent_id:visible');
  if ($parentSelect.length) {
    $parentSelect.select2({
      language: "ja",
      allowClear: true,
      placeholder: $parentSelect.data('placeholder') || '',
      ajax: select2RemoteAjax({
        url: "/contacts.json",
        query: params => ({ search_text_cont_all: params.term })
      }),
      escapeMarkup(markup) { return markup; },
      minimumInputLength: 1
    });
  }

  //$("#contact_prefecture").select2({placeholder: "  都道府県", allowClear: true})

  jpostalPreservingInput("#contact_postal_code", {
    // 郵便番号の入力欄が１つの場合
    // 111-1111と1111111のどちらの入力形式でも住所を自動入力してくれる
    postcode : [ "#contact_postal_code" ],

    // 入力項目フォーマット
    //   %3  都道府県
    //   %4  市区町村
    //   %5  町域
    //   %6  大口事業所の番地
    //   %7  大口事業所の名称
    address  : {
      "#contact_address" : "%3%4%5%6%7"
    }
  });
  jpostalPreservingInput("#contact_company_postal_code", {
    postcode : [ "#contact_company_postal_code" ],
    address  : {
      "#contact_company_address" : "%3%4%5%6%7"
    }
  });
  jpostalPreservingInput("#contact_living_postal_code", {
    postcode : [ "#contact_living_postal_code" ],
    address  : {
      "#contact_living_address" : "%3%4%5%6%7"
    }
  });

  // Auto furigana
  $.fn.autoKana('#contact_last_name', '#contact_last_name_kana', {});
  $.fn.autoKana('#contact_first_name', '#contact_first_name_kana', {});
  $.fn.autoKana('#contact_company_name', '#contact_company_name_kana', {});
  $.fn.autoKana('#contact_rep', '#contact_rep_kana', {});

  // Conflict page
  if ($('#contact_contact_type_person').is(':visible')) {
    if ($('input[name=q\\[contact_type\\]]:checked').val() === 'company') {
      conflict_company();
    } else {
      $('#contact_contact_type_person').prop('checked', true);
      conflict_person();
    }
  }

  $('input[name=q\\[contact_type\\]]:radio').change(function() {
    if ($('#contact_contact_type_person').prop('checked')) {
      conflict_person();
    } else {
      conflict_company();
    }
  });

  $("#joint-names").hide();
  $("#show-joint-names").on('click', function() {
    $("#joint-names").toggle(500);
    $("span", this).toggleClass("fa-minus-square");
    $("span", this).toggleClass("fa-plus-square");
  });

  $("#company-fields").hide();
  $("#show-company-fields").on('click', function() {
    $("#company-fields").toggle(500);
    $("span", this).toggleClass("fa-minus-square");
    $("span", this).toggleClass("fa-plus-square");
  });

  $("#living-fields").hide();
  $("#show-living-fields").on('click', function() {
    $("#living-fields").toggle(500);
    $("span", this).toggleClass("fa-minus-square");
    $("span", this).toggleClass("fa-plus-square");
  });

  // 未入力の検索項目をパラメーターから削除 https://bit.ly/3gGh7mE
  const contact_search = document.getElementById('contact_search');
  if (contact_search) {
    contact_search.addEventListener('submit', function() {
      const allInputs = contact_search.getElementsByTagName('input');
      let i = 0;
      while (i < allInputs.length) {
        const input = allInputs[i];
        if (input.name && !input.value) {
          input.name = '';
        }
        i++;
      }
    });
  }
});

const conflict_person = function() {
  const $formInputs = $('.form-inputs');
  $('#person_input').after($('#company_input'));
  $('#person_label').text($formInputs.data('individual'));
  $('#company_label').text($formInputs.data('affiliation'));
  $('.q_ceo_start').hide();
};
const conflict_company = function() {
  const $formInputs = $('.form-inputs');
  $('#company_input').after($('#person_input'));
  $('#company_label').text($formInputs.data('corporation'));
  $('#person_label').text($formInputs.data('person-in-charge'));
  $('.q_ceo_start').show();
};

})();

window.reloadWithFormat = function(format, extraParams = {}) {
  const origin = (location.origin != null) ? location.origin : `${location.protocol}//${location.host}`;
  const current_search = (location.search != null) ? location.search.replace(/^\?/, '') : '';
  const params = new URLSearchParams(current_search);

  const insertParam = function(key, value) {
    if (value == null) { return; } // skip undefined/null only

    if (Array.isArray(value)) {
      const arrayKey = /\[\]$/.test(key) ? key : `${key}[]`;
      params.delete(arrayKey);
      value.forEach(entry => params.append(arrayKey, entry));
    } else if (Object.prototype.toString.call(value) === '[object Object]') {
      Object.keys(value).forEach(function(childKey) {
        const nestedKey = (key != null) && (key.length > 0) ? `${key}[${childKey}]` : childKey;
        insertParam(nestedKey, value[childKey]);
      });
    } else {
      params.delete(key);
      params.set(key, value);
    }
  };

  if (extraParams != null) {
    Object.keys(extraParams).forEach(rootKey => insertParam(rootKey, extraParams[rootKey]));
  }

  const query = params.toString();
  const suffix = query.length > 0 ? `?${query}` : '';
  location.href = `${origin}${location.pathname}.${format}${suffix}`;
};
